import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { App,LoadingController} from 'ionic-angular';
import { ReportDetail } from '../detail/detail';

@Component({
  templateUrl: 'list.html'
})

export class ReportList {
	issue:string='';
	issues:any=[];
	items:any=[];
	pageIndex = 0;
	pageNumber = 20;
  public loading;

	constructor(public global: AppState,public appCtrl: App,
		private loadCtrl:LoadingController) {
			this.getList();

	}

	getList(){
		this.items = [
		  {"bgtm":"报告题目一","bglx":"报告类型1","tjdw":"提交单位一","xxsm":"学校署名1","tjsj":"2017-11-01","yjxk":"一级学科1","xmly":"项目来源1","zs":"10万","rs":"5","sm":"张三"},
		  {"bgtm":"报告题目2","bglx":"报告类型2","tjdw":"提交单位2","xxsm":"学校署名2","tjsj":"2017-11-02","yjxk":"一级学科2","xmly":"项目来源2","zs":"11万","rs":"7","sm":"李四"},
		  {"bgtm":"报告题目3","bglx":"报告类型3","tjdw":"提交单位3","xxsm":"学校署名3","tjsj":"2017-11-04","yjxk":"一级学科3","xmly":"项目来源3","zs":"15万","rs":"9","sm":"王五"},
		];
		this.issues = [
		  {"value":"2014"},
		  {"value":"2015"},
		  {"value":"2016"},
		  {"value":"2017"},
		];
		this.issue = '2017';
	}

	//跳转详情
	openDetail(item){
		this.appCtrl.getRootNav().push(ReportDetail,item);
	}

	//下拉刷新
  doRefresh(refresher){
  	  setTimeout(() => {
    	 this.pageIndex = 0;
    	 this.items = [];
    	 this.loadData();
    	 refresher.complete();
  	  }, 1000);
  }

  //上拉加载
	loadMore(refresher){
		setTimeout(() => {
				this.pageIndex++;
				this.loadData();
	      refresher.complete();
	  }, 500);

	}

	loadData(){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		if(this.items!=null&&this.items.length>0){
			this.handleList(this.items);
		}
	  this.loading.dismiss();//加载动画结束

	}

	handleList(obj:any){
  	if(obj){
  		var length = obj.length;
  		for(var i=0;i<length;i++){
  			this.items.push(obj[i]);
  		}
		}

  }

	//查询年份
	issueSelect($event){
		console.log($event);
	}
}



// WEBPACK FOOTER //
// ./src/pages/application/research/report/list/list.ts